
import React from "react";
import "./broadCastMessage.scss";
import PropTypes from 'prop-types';
import { generateChatID, userInfo } from "../../../../base/socketChatService/utils";
import { SocketChatService } from "../../../../base/socketChatService";
import { useHistory } from "react-router";
export default function URBroadCast(props: any) {
  const history = useHistory();
  let { name, className,keydata } = props;
 const openChat = (input:any)=>{
  const userDetails = userInfo();
  const socketChat = new SocketChatService(userDetails.fromID, userDetails.domainId);
  let chatDetail ={chatId:generateChatID(userInfo().fromID, input?.sip_login_id?.toString())};
  socketChat.openChatWindow(input,history,chatDetail);
 }
  return (
    <React.Fragment key={keydata}>
       <span  className={className} onClick={()=>name && openChat(name)}>{name ? name?.caller_id : "Unknown User"}</span>
    </React.Fragment>
  );
};

URBroadCast.propTypes = {
  name: PropTypes.any,
  className: PropTypes.any
  
};